import { render, staticRenderFns } from "./BillingOverview.vue?vue&type=template&id=187413c6&scoped=true&"
import script from "./BillingOverview.vue?vue&type=script&lang=js&"
export * from "./BillingOverview.vue?vue&type=script&lang=js&"
import style0 from "./BillingOverview.vue?vue&type=style&index=0&id=187413c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187413c6",
  null
  
)

export default component.exports